var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"nav"},[_c('h2',[_c('router-link',{attrs:{"id":"back","to":{name: 'Menu'}}},[_c('img',{staticClass:"icon",attrs:{"src":require("../assets/meta/back.svg")}})]),_vm._v("Shared Video\n    ")],1)]),_vm._v(" "),(_vm.play)?_c('Video',{attrs:{"title":_vm.title,"videoId":_vm.videoId}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8fbf7cda","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Preview.vue
// module id = null
// module chunks = 